import React, {useContext} from 'react'
import {Typography} from '@mui/material'
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";

const Copyright = (props: any) => {
    const { t } = useContext(OrgCustomizationContext)

    return (
        <div style={{ marginTop: 60, marginBottom: 30 }}>
            <Typography variant='body2' color='textSecondary' align='center'>
                {t('copyright', { year: new Date().getFullYear().toString() })}
            </Typography>
        </div>
    )
}

export default Copyright
